import {Component, EventEmitter, forwardRef, Injector, Input, Output} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ColorEditControlComponent),
    multi: true
};

@Component({
    providers: [CUSTOM_VALUE_ACCESSOR],
    selector: "wbo-color-edit-control",
    templateUrl: "./color-edit-control.component.html",
})
export class ColorEditControlComponent extends AbstractEditControlComponent {
    @Input() allowAlpha: boolean = true;
    @Input() showClearOption: boolean = false;
    @Output() onClear: EventEmitter<void> = new EventEmitter<void>();

    public static toColorHex(value: number): string {
        if (value == undefined) {
            return undefined;
        }
        const rgb: number = value & 0xFFFFFF;
        const alpha: number = (value >>> 24) & 0xFF;
        return "#" + ("00000" + rgb.toString(16)).slice(-6) + ("0" + alpha.toString(16)).slice(-2);
    }

    public static fromColorHex(value: string): number {
        if (value == undefined) {
            return undefined;
        }
        const colour: number = Number(value.replace("#", "0x"));
        const rgb = colour >>> 8;
        const alpha = colour & 0xFF;
        return (alpha << 24) | rgb;
    }

    constructor(injector: Injector) {
        super(injector);
    }
}
